import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const getEmails = () => {
  return axiosPrivate.get('/dashboard/api/v1/merchant/notification/emails');
};

export const addEmail = (payload: { email: string; category: string }) => {
  return axiosPrivate.post(
    '/dashboard/api/v1/merchant/notification/add-email',
    payload
  );
};

export const deleteEmail = (payload: { email: string; category: string }) => {
  return axiosPrivate.post(
    '/dashboard/api/v1/merchant/notification/remove-email',
    payload
  );
};

export const resendOtp = (payload: { email: string }) => {
  return axiosPrivate.post(
    '/dashboard/api/v1/merchant/notification/resend-otp',
    payload
  );
};

export const verifyEmail = ({
  payload,
  otp,
}: {
  payload: { email: string; category: string };
  otp: string;
}) => {
  return axiosPrivate.post(
    `/dashboard/api/v1/merchant/notification/verify-otp?otp=${otp}`,
    payload
  );
};
